'use strict'

import React from 'react'
import { ChromePicker } from 'react-color'
import {Square} from "@phosphor-icons/react";

class ColorPicker extends React.Component {
	
	state = {
		displayColorPicker: false,
		color:"#000000"
	};
	constructor(props) {
		
		super(props);
		
		
		if(this.props.color)
			this.state = {
				color:this.props.color
			};
		
	}
	
	updateStatus(s){
		var x = {...this.state, ...s};
		this.setState(x);
		this.forceUpdate();
	}

	currentColor(){
		return this.state.color;
	}
	changeColor(color){
		if(this.props.onChange){
			this.props.onChange(color);
		}
		this.updateStatus({color:color})
		
	}
	handleChangeComplete(hex){
		if(this.props.onChangeComplete)
			this.props.onChangeComplete(hex);
	}
	handleColorInput(e){
		if(e.target.innerText.match(/^#(?:[0-9a-f]{3}){1,2}$/i)){
			this.changeColor(e.target.innerText);
		}
		return false;
	}
	preventDefaults(e){
		
		if(e.key==='Enter'){
			e.preventDefault();
			return false;
		}
		return true;
		
	}
	render() {

		return (
			<div className={"color-picker " + (this.props.hideHex ? 'hideHex' : '')}>
				<span className="color-wrapper" onClick={(e)=>this.updateStatus({displayColorPicker:true}) }>
					<div className="square" style={{backgroundColor:this.state.color}}></div>
					<span contentEditable="true" suppressContentEditableWarning={true} onKeyPress={(e)=>{return this.preventDefaults(e);}} onInput={(e)=>{this.handleColorInput(e)}}>{this.state.color}</span>
				</span>
				<input type="hidden" name="color" value={this.state.color} />
				{ 
					this.state.displayColorPicker && 
					<div className="choose">
						<div className="cover" onClick={ (e)=>this.updateStatus({displayColorPicker:false}) }/>
						<ChromePicker disableAlpha={true} color={ this.state.color } onChangeComplete={(color)=>{this.handleChangeComplete(color.hex)}} onChange={(color)=>this.changeColor(color.hex)}  />
					</div> 
				}
			</div>
		)
	}
}

export default ColorPicker
